import * as React from 'react';
export const ZMSvg = React.forwardRef(function ZMSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#159570',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M10 5h2v7h-2z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        d: 'M12 5h2v7h-2z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F79A59',
        d: 'M16 5v4.991A2.003 2.003 0 0 1 14.006 12L14 5h2Zm-5-3h4v1h-4V2Z',
      }),
    ),
  );
});
ZMSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var ZM = {
  category: 'flag',
  colorable: false,
  name: 'ZM',
  svg: ZMSvg,
};
